module.exports = __webpack_public_path__ + "img/sbr.b889c87d.png";